import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
  },
  content: {
    paddingTop: 150,
    textAlign: 'center'
  },
  panelSpacer: {
    width: 1,
    minHeight: 208,
}
}));

const NotFound = () => {
  const classes = useStyles();

  return (
   //  <div className={classes.root}>
<div>
      <Grid
        container
        justify="center"
        spacing={4}
      >
        <Grid
          item
          lg={6}
          xs={12}
        >
          <div className={classes.content}>
              <div className={classes.panelSpacer} />
            <Typography variant="h5">
              These are not the pages you're looking for.
            </Typography>
            <div>
                <Button variant="contained" color="primary" href="/" style={{margin: 24, marginBottom: 500}}>
                    Circle on back home
                </Button>
            </div>

            Error: 404
            

          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default NotFound;
